import { useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";
import { Tooltip } from "antd";


//Chi tiết KTV - Chi tiết đơn phục vụ
const ViewDetailOrderServiceUser = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    function convertDateTime(event) {
        let date = new Date(event),
            month = date.getMonth() + 1,
            day = date.getDate();
        if (day < 10) day = '0' + day;
        if (month < 10) month = '0' + month;
        let text = date.getFullYear() + '-' + month + '-' + day ;
        return text
    };

    const columns = [
        {
            title: 'Ngày phục vụ',
            dataIndex: 'order_at',
            // align: "center",
            fixed : 'left',
            width: 150,
            render: (data) => {
                return (
                    <p className="text4">{convertDateTime(data)}</p>
                )
            },
        },
        {
            title: 'Mã hoá đơn',
            dataIndex: 'order_code',
            // align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Khách hàng',
            // align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="text1">{data.customer_name}<br/>{data.customer_mobile}</p>
                )
            },
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'service_name',
            // align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Tổng số tiền kỹ thuật viên được nhận khi phục vụ dịch vụ cho khách hàng.'> Thưởng phục vụ <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'com_ktv',
            align: "center",
            width: 150,

            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Số người phục vụ',
            title: <Tooltip className="show-tooltip" title='Tổng số kỹ thuật viên phục vụ dịch vụ cho khách hàng.'> Số người phục vụ <i className="fas fa-info-circle"></i></Tooltip>,

            dataIndex: 'count_ktv',
            align: "center",
            width: 150,

            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
    ];

    const handelExportUser = () => {
        setShowLoading(true)
      
        let url = `api/mysql/export/detail-user?type=1&user_id=${props.userId}&user_name=${props.userName}&start=${props.startDate}&end=${props.endDate}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }
  
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                <div className="border-bottom w-100">
                    <Row className="mb-2">
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button>
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    onChange={handleChange}
                    bordered
                    rowKey="id"
                />
            </div>
            <Loading show={showLoading} />
        </>
    )
}
export default ViewDetailOrderServiceUser